<script setup>
// U1 of the unified gateway (UNIFIED-AUTOMATION-INTEGRATIONS-ARCHITECTURE):
// one page, two tabs, zero server-side change. Both screens are embedded
// exactly as they are - each keeps its own engine, store and behavior.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import AutomationRules from './Index.vue';
import TeletelFlowsList from '../teletelFlows/Index.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

// The tab lives in the query string so links stay deep-linkable and the
// old /settings/automation/list URL keeps opening the rules, unchanged.
const activeTab = computed(() =>
  route.query.tab === 'flows' ? 'flows' : 'rules'
);
const openTab = tab =>
  router.replace({ query: { ...route.query, tab } }).catch(() => {});

const tabClass = tab =>
  activeTab.value === tab
    ? 'border-n-brand text-n-slate-12 border-b-2 font-medium'
    : 'border-transparent text-n-slate-11 hover:text-n-slate-12 border-b-2';
</script>

<template>
  <div class="flex flex-col w-full h-full min-h-0">
    <div class="px-6 pt-4">
      <p class="text-sm text-n-slate-11">
        {{ t('AUTOMATION_FLOWS_GATEWAY.DESCRIPTION') }}
      </p>
      <div class="mt-3 flex gap-4 border-b border-n-weak">
        <button
          class="pb-2 text-sm transition-colors"
          :class="tabClass('rules')"
          @click="openTab('rules')"
        >
          {{ t('AUTOMATION_FLOWS_GATEWAY.TAB_RULES') }}
        </button>
        <button
          class="pb-2 text-sm transition-colors"
          :class="tabClass('flows')"
          @click="openTab('flows')"
        >
          {{ t('AUTOMATION_FLOWS_GATEWAY.TAB_FLOWS') }}
        </button>
      </div>
    </div>

    <div class="flex-1 min-h-0 overflow-auto">
      <AutomationRules v-if="activeTab === 'rules'" />
      <TeletelFlowsList v-else />
    </div>
  </div>
</template>
